import {
  advancedFormControl,
  advancedFormGroup,
  FormControlTypeEnum,
} from '@magieno/common';
import { IsInt, IsNotEmpty, ValidateNested } from '@pristine-ts/class-validator';
import { FieldTypeEnum } from '../../../../../enums/field-type.enum';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { ErrorMessageBuilder } from '../../../../../builders/error-message.builder';
import { type } from '@pristine-ts/data-mapping-common';
import { IncomeTaxPersonalSpouseCommonOptions } from '../common/income-tax-personal-spouse-common.options';
import {
  IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions,
} from './income-tax-personal-spouse-federal-in-income-tax-personal.options';

@translationBaseKey('income-tax-personal-spouse-options')
export class IncomeTaxPersonalSpouseOptions extends IncomeTaxPersonalSpouseCommonOptions {
  @type(() => new IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions,
  })
  @ValidateNested()
  federal: IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Gain en capital (perte en capital en négatif)',
        en: 'Negative capital gain or loss',
      },
      tooltip: {
        fr: 'Indiquez le montant du gain en capital ou de la perte en capital (négatif) sur la disposition d\'actions côtés en bourse, de biens amortissables, d\'obligations et autres. Ces montants peuvent avoir un impact sur les impôts.',
        en: 'Specify the amount of negative capital gain or loss on the disposition of publicly traded stocks, depreciable property, bonds, and similar items. These amounts may have tax implications.',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  gainPubliclyTradeShares: number;
}

